import * as React from "react";
import { Header as BaseHeader, StrictHeaderProps } from "semantic-ui-react";
import { ColorProp } from "../../../constants/type";
import { getColor } from "../../../utils/get-color";
interface IHeader extends StrictHeaderProps {
  underline?: boolean;
  shade?: ColorProp;
  children: string;
  style?: any;
}

class Header extends React.Component<IHeader> {
  public render() {
    const { underline, style, children, size, ...rest } = this.props;
    const textColor = this.textColor();
    const textSize: any = this.textSize();
    return (
      <BaseHeader
        style={{
          color: textColor,
          textDecoration: underline ? "underline" : "none",
          ...style,
        }}
        size={textSize}
        {...rest}
      >
        {children}
      </BaseHeader>
    );
  }

  private textColor = () => {
    const { shade } = this.props;
    return getColor(shade);
  };

  private textSize = () => {
    const { size } = this.props;
    return size;
  }
}

export default Header;
